import { useAtomValue } from 'jotai';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Skeleton } from '../ui/skeleton';
import { caCheckAtom } from '@/atoms/caCheck';

export const Analysis = () => {
  const caCheckResult = useAtomValue(caCheckAtom);
  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle>Analysis</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        {caCheckResult?.message ? (
          caCheckResult?.message.split('\n').map((paragraph, index) => (
            <p key={index} className="text-white">
              {paragraph}
            </p>
          ))
        ) : (
          <div className="flex flex-col gap-2">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>
            <div className="flex flex-col gap-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
